import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";

const Profile = () => {
  const { workerUser } = useOutletContext();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isLeftActive, setIsLeftActive] = useState(false);
  const [isRightActive, setIsRightActive] = useState(true);
  const [isAvailabilityUpdated, setAvailabilityUpdated] = useState(false);
  const [isServiceRatesUpdated, setServiceRatesUpdated] = useState(false);
  const [isServiceLocationsUpdated, setServiceLocationsUpdated] =
    useState(false);
  const [isExperienceUpdated, setExperienceUpdated] = useState(false);
  const [isProfilePhotoUpdated, setProfilePhotoUpdated] = useState(false);
  const [isBioUpdated, setBioUpdated] = useState(false);
  const [isPaymentDetailsUpdated, setPaymentDetailsUpdated] = useState(false);
  const [isEmploymentHistoryUpdated, setEmploymentHistoryUpdated] =
    useState(false);
  const [isEducationHistoryUpdated, setEducationHistoryUpdated] =
    useState(false);
  const [isBadgesUpdated, setBadgesUpdated] = useState(false);
  const [isImmunizationUpdated, setImmunizationUpdated] = useState(false);
  const [isLanguagesUpdated, setLanguagesUpdated] = useState(false);
  const [isCulturalBackgroundUpdated, setCulturalBackgroundUpdated] =
    useState(false);
  const [isReligionsUpdated, setReligionsUpdated] = useState(false);
  const [isHobbiesUpdated, setHobbiesUpdated] = useState(false);
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    const handleResize = () => {
      const small = window.innerWidth <= 768;
      console.log("Current window width:", window.innerWidth, "isSmallScreen:", small);
      setIsSmallScreen(small);
      if (!small) {
        setIsLeftActive(true);
        setIsRightActive(true);
      } else {
        setIsLeftActive(true);
        setIsRightActive(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (workerUser && workerUser.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${workerUser.id}`
          );
          const userData = response.data;

          if (userData) {
            console.log(
              "Data fetched on component mount or user/baseURL change"
            );
            setAvailabilityUpdated(userData.availability.availabilityUpdated);
            setServiceRatesUpdated(userData.serviceRatesUpdated);
            setServiceLocationsUpdated(userData.serviceLocationsUpdated);
            setExperienceUpdated(userData.experience.experienceUpdated);
            setProfilePhotoUpdated(userData.profilePhotoUpdated);
            setBioUpdated(userData.bioUpdated);
            setPaymentDetailsUpdated(userData.paymentDetailsUpdated);
            setEmploymentHistoryUpdated(userData.employmentHistoryUpdated);
            setEducationHistoryUpdated(userData.educationHistoryUpdated);
            setBadgesUpdated(userData.badgesUpdated);
            setImmunizationUpdated(userData.vaccinesUpdated);
            setLanguagesUpdated(userData.languagesUpdated);
            setCulturalBackgroundUpdated(userData.culturalBackgroundUpdated);
            setReligionsUpdated(userData.religionUpdated);
            setHobbiesUpdated(userData.hobbiesUpdated);
          }
        } catch (error) {
          console.error("Failed to fetch User Data:", error);
        }
      }
    };

    fetchData();

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is now visible, fetching data...");
        await fetchData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [workerUser, baseURL]);

  const activeLinkStyle = ({ isActive }) =>
    isActive
      ? {
        backgroundColor: "#f5f5f5",
        color: "#145966",
        padding: "5px 15px 6px 10px",
        fontWeight: "500",
      }
      : undefined;

  const handleNavClick = () => {
    console.log("Nav item clicked", isSmallScreen);
    if (isSmallScreen) {
      setIsLeftActive(false);
      setIsRightActive(true);
    }
  };

  const handleBackClick = () => {
    if (isSmallScreen) {
      setIsLeftActive(true);
      setIsRightActive(false);
    }
  };

  return (
    <div className="profile-container">
      {isLeftActive && (
      <div className="profile-left-container">
        <div className="profile-left-div">
          <h4>Work Details</h4>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isAvailabilityUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/availability"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Availability
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isServiceRatesUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/service-rates"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Service Rates
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isServiceLocationsUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/locations"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Locations
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isExperienceUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/experience"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Experience
            </NavLink>
          </div>
        </div>
        <div className="profile-left-div">
          <h4>Personal Details</h4>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isProfilePhotoUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/photo"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Photo
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isBioUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/bio"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Bio
            </NavLink>
          </div>
        </div>

        <div className="profile-left-div">
          <h4>Additional Details</h4>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isPaymentDetailsUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/payment-details"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Payment Details
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isEmploymentHistoryUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/employment-history"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Employment History
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isEducationHistoryUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/education-and-training"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Training & Certs
            </NavLink>
          </div>

          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isBadgesUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/badges"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Badges
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isImmunizationUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/immunization"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Vaccination
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isLanguagesUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/languages"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Languages
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isCulturalBackgroundUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/cultural-background"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Cultural Background
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isReligionsUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/religion"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Religion
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input
              type="checkbox"
              className="rounded-checkbox"
              checked={isHobbiesUpdated}
              readOnly
            />
            <NavLink
              to="/account/ps-dashboard/profile/hobbies"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Interests & Hobbies
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input type="checkbox" className="rounded-checkbox" readOnly />
            <NavLink
              to="/account/ps-dashboard/profile/child-care"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              Child Care
            </NavLink>
          </div>
          <div className="profile-link-container">
            <input type="checkbox" className="rounded-checkbox" readOnly />
            <NavLink
              to="/account/ps-dashboard/profile/ndis-screening"
              className="profile-link"
              style={activeLinkStyle}
              onClick={handleNavClick}
            >
              NDIS Worker Screening
            </NavLink>
          </div>
        </div>
      </div>
      )}
      {isRightActive && (
        <div className="profile-right-container">
          <Outlet context={{ isSmallScreen, handleBackClick }} />
        </div>
      )}
    </div>
  );
};

export default Profile;
